import ErrorMessage from 'components/ErrorMessage'
import OButton from 'components/reusable/OButton'
import SubscriptionInput from 'components/reusable/SubscriptionInput'
import AuthContext from 'context/AuthContext'
import useToastContext from 'hooks/useToastContext'
import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { apiGet, apiPut } from 'utils/apiFetch'
import apiPath from 'utils/apiPath'
import formValidation from 'utils/formValidation'

function SubscriptionPlan ({ name ,manager}) {
  const { t } = useTranslation()
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'onBlur',
    shouldFocusError: true
  })
  const notification = useToastContext()
  const {config,user} = useContext(AuthContext)
  const [subscription, setSubscription] = useState('')
  const [subscriptionList, setSubscriptionList] = useState([])
  const onSubmit = async data => {
    try {
      const payload = { name, ...data }
      const { data: response } = await apiPut(
        apiPath.ListSubscriptions + '/' + subscription?._id,
        payload
      )
      if (response?.success) {
        notification.success(response?.message)
        getSubscription()
      } else {
        notification.error(response.message)
      }
    } catch (error) {
      console.error(error)
    }
  }
  const setSubscriptionPlan = subscriptionPlan => {
    setSubscription(subscriptionPlan)

    setValue('oneMonthPrice', subscriptionPlan?.oneMonthPrice)
    setValue('oneMonthAgents', subscriptionPlan?.oneMonthAgents)
    setValue('oneMonthProperties', subscriptionPlan?.oneMonthProperties)
    setValue('threeMonthPrice', subscriptionPlan?.threeMonthPrice)
    setValue('threeMonthAgents', subscriptionPlan?.threeMonthAgents)
    setValue('threeMonthProperties', subscriptionPlan?.threeMonthProperties)
    setValue('sixMonthPrice', subscriptionPlan?.sixMonthPrice)
    setValue('sixMonthAgents', subscriptionPlan?.sixMonthAgents)
    setValue('sixMonthProperties', subscriptionPlan?.sixMonthProperties)
    setValue('oneYearPrice', subscriptionPlan?.oneYearPrice)
    setValue('oneYearAgents', subscriptionPlan?.oneYearAgents)
    setValue('oneYearProperties', subscriptionPlan?.oneYearProperties)
  }
  const getSubscription = async () => {
    const { data: response } = await apiGet(apiPath.ListSubscriptions)

    const subscriptionPlan = response?.results?.find(
      item => item?.name === 'Basic'
    )
    setSubscriptionList(response?.results)
    setSubscriptionPlan(subscriptionPlan)
  }
  useEffect(() => {
    getSubscription()
  }, [])
  useEffect(() => {
    if (subscriptionList?.length > 0) {
      const subscriptionPlan = subscriptionList?.find(
        item => item?.name === name
      )
      setSubscriptionPlan(subscriptionPlan)
    }
  }, [name])
  return (
    <div className='relative  flex-auto p-3'>
      <div className=' border-2 rounded-md p-5'>
        <div className='grid grid-cols-4 '>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_DURATION')}</strong>
            </div>
            <div ClassName='relative z-0   w-full group'>
              <div
                placeholder='1 Month'
                className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
              >
                1 Month
              </div>
            </div>
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_PACKAGE_PRICE')}</strong>
            </div>
            {/* <SubscriptionInput
              wrapperClassName='relative z-0   w-full group'
              name='oneMonthPrice'
              type='number'
              register={register('oneMonthPrice', formValidation.packagePrice)}
              errors={errors}
            /> */}
            <div className='relative z-0   w-full group flex border-2 rounded-lg'>
              <span className=' font-medium block p-5 py-4 bg-gray-200 '>
                {config?.currency}
              </span>
              <input
                type='number'
                name='oneMonthPrice'
                id='oneMonthPrice'
                className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent  border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                {...register('oneMonthPrice', {
                  required: 'Please enter package price.',
                  validate: val => {
                    if (val <= 0) {
                      return 'Value must be greater than 0.'
                    }
                  }
                })}
              />
            </div>
            <ErrorMessage message={errors?.oneMonthPrice?.message} />
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_AGENT_LISTING')}</strong>
            </div>
            <SubscriptionInput
              wrapperClassName='relative z-0   w-full group'
              name='oneMonthAgents'
              type='number'
              register={register('oneMonthAgents', formValidation.agentListing)}
              errors={errors}
            />
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_PROPERTY_LISTING')}</strong>
            </div>
            <SubscriptionInput
              wrapperClassName='relative z-0   w-full group'
              name='oneMonthProperties'
              type='number'
              register={register(
                'oneMonthProperties',
                formValidation.propertyListing
              )}
              errors={errors}
            />
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_DURATION')}</strong>
            </div>
            <div ClassName='relative z-0   w-full group'>
              <div
                placeholder='3 Months'
                className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
              >
                3 Months
              </div>
            </div>
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_PACKAGE_PRICE')}</strong>
            </div>
            {/* <SubscriptionInput
              wrapperClassName='relative z-0   w-full group'
              name='threeMonthPrice'
              type='number'
              register={register(
                'threeMonthPrice',
                formValidation.packagePrice
              )}
              errors={errors}
            /> */}
            <div className='relative z-0   w-full group flex border-2 rounded-lg'>
              <span className=' font-medium block p-5 py-4 bg-gray-200 '>
                {config?.currency}
              </span>
              <input
                type='number'
                name='threeMonthPrice'
                id='threeMonthPrice'
                className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent  border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                {...register('threeMonthPrice', {
                  required: 'Please enter package price.',
                  validate: val => {
                    if (val <= 0) {
                      return 'Value must be greater than 0.'
                    }
                  }
                })}
              />
            </div>
            <ErrorMessage message={errors?.threeMonthPrice?.message} />
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_AGENT_LISTING')}</strong>
            </div>
            <SubscriptionInput
              wrapperClassName='relative z-0   w-full group'
              name='threeMonthAgents'
              type='number'
              register={register(
                'threeMonthAgents',
                formValidation.agentListing
              )}
              errors={errors}
            />
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_PROPERTY_LISTING')}</strong>
            </div>
            <SubscriptionInput
              wrapperClassName='relative z-0   w-full group'
              name='threeMonthProperties'
              type='number'
              register={register(
                'threeMonthProperties',
                formValidation.propertyListing
              )}
              errors={errors}
            />
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_DURATION')}</strong>
            </div>
            <div ClassName='relative z-0   w-full group'>
              <div
                placeholder='6 Months'
                className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
              >
                6 Months
              </div>
            </div>
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_PACKAGE_PRICE')}</strong>
            </div>
            {/* <SubscriptionInput
              wrapperClassName='relative z-0   w-full group'
              name='sixMonthPrice'
              type='number'
              register={register('sixMonthPrice', formValidation.packagePrice)}
              errors={errors}
            /> */}
            <div className='relative z-0   w-full group flex border-2 rounded-lg'>
              <span className=' font-medium block p-5 py-4 bg-gray-200 '>
                {config?.currency}
              </span>
              <input
                type='number'
                name='sixMonthPrice'
                id='sixMonthPrice'
                className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent  border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                {...register('sixMonthPrice', {
                  required: 'Please enter package price.',
                  validate: val => {
                    if (val <= 0) {
                      return 'Value must be greater than 0.'
                    }
                  }
                })}
              />
            </div>
            <ErrorMessage message={errors?.sixMonthPrice?.message} />
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_AGENT_LISTING')}</strong>
            </div>
            <SubscriptionInput
              wrapperClassName='relative z-0   w-full group'
              name='sixMonthAgents'
              type='number'
              register={register('sixMonthAgents', formValidation.agentListing)}
              errors={errors}
            />
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_PROPERTY_LISTING')}</strong>
            </div>
            <SubscriptionInput
              wrapperClassName='relative z-0   w-full group'
              name='sixMonthProperties'
              type='number'
              register={register(
                'sixMonthProperties',
                formValidation.propertyListing
              )}
              errors={errors}
            />
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_DURATION')}</strong>
            </div>
            <div ClassName='relative z-0   w-full group'>
              <div
                placeholder='1 Year'
                className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
              >
                1 Year
              </div>
            </div>
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_PACKAGE_PRICE')}</strong>
            </div>
            {/* <SubscriptionInput
              wrapperClassName='relative z-0   w-full group'
              name='oneYearPrice'
              type='number'
              register={register('oneYearPrice', formValidation.packagePrice)}
              errors={errors}
            /> */}
            <div className='relative z-0   w-full group flex border-2 rounded-lg'>
              <span className=' font-medium block p-5 py-4 bg-gray-200 '>
                {config?.currency}
              </span>
              <input
                type='number'
                name='oneYearPrice'
                id='oneYearPrice'
                className='block py-4 px-3 w-full text-sm text-gray-900 bg-transparent  border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer'
                {...register('oneYearPrice', {
                  required: 'Please enter package price.',
                  validate: val => {
                    if (val <= 0) {
                      return 'Value must be greater than 0.'
                    }
                  }
                })}
              />
            </div>
            <ErrorMessage message={errors?.oneYearPrice?.message} />
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_AGENT_LISTING')}</strong>
            </div>
            <SubscriptionInput
              wrapperClassName='relative z-0   w-full group'
              name='oneYearAgents'
              type='number'
              register={register('oneYearAgents', formValidation.agentListing)}
              errors={errors}
            />
          </div>
          <div className='m-3'>
            <div className=''>
              <strong>{t('O_PROPERTY_LISTING')}</strong>
            </div>
            <SubscriptionInput
              wrapperClassName='relative z-0   w-full group'
              name='oneYearProperties'
              type='number'
              register={register(
                'oneYearProperties',
                formValidation.propertyListing
              )}
              errors={errors}
            />
          </div>
        </div>
        {(manager?.add || user?.role === 'admin') && (
        <div className='flex items-center justify-center p-3'>
          <OButton
            disabled={!isDirty}
            label={<>{t('O_UPDATE')}</>}
            type='submit'
            onClick={handleSubmit(onSubmit)}
          />
        </div>)}
      </div>
    </div>
  )
}

export default SubscriptionPlan
